export default {
  getProgramYear: (state) => `${state.programYear}`,
  programIsSet: (state) => (!!state.programYear),
  getOptions: (state) => state.options,
};
